module.exports = __webpack_public_path__ + "img/2_8.6ceef963.jpg";